module.exports = __webpack_public_path__ + "static/media/road_surface_estimator.f1facf95.md";